"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _Text = _interopRequireDefault(require("../../../core/Text"));
var _react2 = require("@emotion/react");
var _useIsMobile = require("../../../hooks/useIsMobile");
var _Item = _interopRequireDefault(require("../../../core/List/Item"));
var _Button = _interopRequireDefault(require("../../../core/Button"));
var _react3 = require("motion/react");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const SubmenuItem = ({
  lightTheme,
  active,
  label,
  className,
  showActiveitemLabel,
  onClick,
  onChange
}) => {
  const theme = (0, _react2.useTheme)();
  const isMobile = (0, _useIsMobile.useIsMobile)();
  const handleOptionClick = () => {
    onClick && onClick();
    onChange && onChange();
  };
  const labelColor = lightTheme ? theme.secondaryDarkText : !active ? theme.submenuTextColor : theme.submenuTextColorActive;
  if (showActiveitemLabel) {
    if (active) {
      return (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: label
      });
    }
    return null;
  }
  return !isMobile ? (0, _jsxRuntime.jsx)(_Item.default, {
    children: (0, _jsxRuntime.jsx)(_Button.default, {
      role: "menuitem",
      "aria-current": active ? 'page' : undefined,
      nostyle: true,
      onClick: onClick,
      css: (0, _styles.FocusState)(lightTheme ? theme.primary : 'white'),
      trackingName: "Submenu",
      trackingEvent: 'Submenu click: ' + label,
      className: className,
      children: (0, _jsxRuntime.jsx)(_react3.AnimatePresence, {
        children: (0, _jsxRuntime.jsx)(_styles.Wrapper, {
          active: active,
          lightTheme: lightTheme,
          background: lightTheme ? '#ffffff' : theme.submenuItemColor,
          initial: {
            opacity: 0
          },
          animate: {
            opacity: 1
          },
          exit: {
            opacity: 0
          },
          transition: {
            duration: 0.1
          },
          children: (0, _jsxRuntime.jsx)(_Text.default, {
            color: labelColor,
            semibold: true,
            children: label
          })
        })
      })
    })
  }) : (0, _jsxRuntime.jsx)(_Item.default, {
    children: (0, _jsxRuntime.jsx)(_Button.default, {
      role: "menuitem",
      "aria-current": active ? 'page' : undefined,
      nostyle: true,
      css: _styles.optionButton,
      onClick: handleOptionClick,
      children: label
    })
  });
};
var _default = exports.default = SubmenuItem;